export default __webpack_public_path__ + "static/media/exp_face_shape.bf4ed71d.svg";